import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 메인 내비게이션 배치 제어 컴포넌트
 * 원본: nav-layout-control.html
 */
const NavLayoutControl = () => {
  const themeContext = useTheme();
  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;

  return (
    <div id="nav-layout-control-section" style={{ marginBottom: '20px' }}>
      <div className="nav-layout-control-header" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
        <label style={{ display: 'block', fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>
          📐 메인 내비게이션 배치:
        </label>
        <button
          type="button"
          className="theme-help-btn"
          data-target="nav-layout-control-section"
          title="이 항목으로 이동"
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            width: '20px',
            height: '20px',
            padding: 0,
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ?
        </button>
      </div>
      <CustomSelect
        inputId="nav-layout-selector"
        value={themeConfig.navLayout}
        onChange={(v) => set('navLayout', v)}
        isSearchable={false}
        isClearable={false}
        options={[
          { value: 'top', label: '상단 (Top)' },
          { value: 'left', label: '좌측 (Left Sidebar)' },
          { value: 'right', label: '우측 (Right Sidebar)' },
        ]}
        styles={{
          control: (base, state) => ({
            ...base,
            width: '100%',
            minHeight: 36,
            fontSize: 13,
            borderRadius: 4,
            borderColor: state.isFocused ? '#86b7fe' : '#ddd',
          }),
          valueContainer: (base) => ({ ...base, padding: '0 10px' }),
          indicatorsContainer: (base) => ({ ...base, height: 36 }),
        }}
      />
      <div className="nav-layout-control-description" style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>
        메인 내비게이션 메뉴의 위치를 설정합니다.
      </div>
    </div>
  );
};

export default NavLayoutControl;

